import { Tooltip } from "antd";
import "./QotdQuote.scss";

// The header clamps the quote to two lines, so hovering reveals it in full.
function QotdQuote({ qotd, canEdit, onEdit, isDarkMode }) {
  const hasQuote = !!qotd?.quote;

  const body = (
    <span
      className="qotdBody"
      // A triple click is deliberate enough not to fire while someone is only
      // selecting the text to copy it.
      onClick={(e) => {
        if (canEdit && e.detail >= 3) onEdit();
      }}
    >
      {/* An admin can clear the quote, and then the author must go too rather
          than leaving a dangling "- Name". */}
      {hasQuote && (
        <span className="qotdMain">
          {`${qotd.quote}${qotd?.author ? ` - ${qotd.author}` : ""}`}
        </span>
      )}
      {/* The corpus is English and the line above is a translation, so the
          original stays visible underneath. */}
      {!!qotd?.quoteEn && <span className="qotdOriginal">{qotd.quoteEn}</span>}
    </span>
  );

  if (!hasQuote) {
    return <span className="qotdTrigger">{body}</span>;
  }

  return (
    <Tooltip
      placement="bottomLeft"
      mouseEnterDelay={0.4}
      classNames={{ root: `qotdTooltip ${isDarkMode ? "dark" : ""}` }}
      title={
        <div className="qotdTooltipCard">
          <span className="mark">“</span>
          <p className="sq">{qotd.quote}</p>
          {!!qotd?.quoteEn && <p className="en">{qotd.quoteEn}</p>}
          {!!qotd?.author && <p className="author">{qotd.author}</p>}
          {canEdit && (
            <p className="hint">Kliko tri herë mbi citim për ta ndryshuar</p>
          )}
        </div>
      }
    >
      <span className="qotdTrigger">{body}</span>
    </Tooltip>
  );
}

export default QotdQuote;
